// components/customFunctionalComponents/components/ProtocoloCard.jsx
import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faPlus } from "@fortawesome/free-solid-svg-icons";

export const ProtocoloCard = ({ protocolo, negocioNombre, negocioImagenUrl, cedisNombre, onEditClick, onCardClick, hasProtocols }) => {
    const imagenBgColor = '#0000'; // blanco
    const cardBorderColor = '#ddd'; //gris claro
    const tituloColor = '#333'; //gris muy oscuro
    const parrafoColor = '#666'; //gris medio
    const primaryColor = '#264369'; // azul del bootstrap primary
    const defaultTextoBgColor = '#0000'; // balnco para la zona inferior de la tarjeta
    const textoBgColor = hasProtocols ? primaryColor : defaultTextoBgColor; //El color varia si tiene informacion de protocolos o no

    const defaultTextColor = '#333';
    const invertedTextColor = '#ffffff';

    const iconToShow = hasProtocols ? faPencil : faPlus;
    const iconTitle = hasProtocols ? "EditarProtocolo" : "Agregar Protocolo";

    // Función para manejar el clic en la tarjeta (excluyendo el botón de editar)
    const handleCardClick = (e) => {
        // Prevenir la propagación del evento si el clic proviene del botón de editar
        // Esto asegura que solo la tarjeta (y no el botón) abra el SideCard
        if (e.target.closest('a')) { // Si el clic fue en el <a> que envuelve el icono
            return;
        }
        if (onCardClick) {
            onCardClick(protocolo);
        }
    };

    return (
        <div
            style={{
                border: `1px solid ${cardBorderColor}`,
                padding: '0px',
                margin: '0px',
                borderRadius: '8px',
                textAlign: 'left',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                backgroundColor: '#fff',
                width: '200px', // Ancho fijo de la tarjeta
                height: '100%',
                flexShrink: 0,
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                cursor: 'pointer' // Indica que la tarjeta es clickeable
            }}
            onClick={handleCardClick} // Agregamos el onClick a la tarjeta completa
        >
            {/* Contenedor de la imagen */}
            <div style={{
                height: '100px',
                padding: '20px',
                overflow: 'hidden',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: imagenBgColor,
                borderBottom: `1px solid ${cardBorderColor}`
            }}>
                {negocioImagenUrl && (
                    <img
                        src={negocioImagenUrl}
                        alt={`Logo de ${negocioNombre}`}
                        style={{
                            maxWidth: '100%',
                            maxHeight: '100%',
                            objectFit: 'contain'
                        }}
                    />
                )}
            </div>

            <div
                style={{
                    padding: '10px',
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    textAlign: 'left',
                    backgroundColor: textoBgColor,
                    color: hasProtocols ? invertedTextColor : defaultTextColor
                }}>
                <h4 style={{ margin: '0 0 10px 0', fontSize: '1.2em', color: hasProtocols ? invertedTextColor : tituloColor, textTransform: 'uppercase' }}>
                    <strong>{protocolo.titulo_protocolo}</strong>
                </h4>
                <p style={{ margin: '0 0 5px 0', fontSize: '0.9em', color: hasProtocols ? invertedTextColor : parrafoColor }}>NEGOCIO: {negocioNombre}</p>
                <p style={{ margin: '0 0 15px 0', fontSize: '0.9em', color: hasProtocols ? invertedTextColor : parrafoColor }}>CEDIS: {cedisNombre}</p>

                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'left' }}>
                    {/* Botón de Editar */}
                    <a onClick={(e) => {
                        e.stopPropagation(); // Evita que el clic en el icono propague a la tarjeta
                        onEditClick(protocolo);
                    }}>
                        <FontAwesomeIcon
                            icon={iconToShow}
                            className="fa pb-2 mr-2"
                            style={{ fontSize: '1.2em', cursor: 'pointer', marginRight: '10px', color: hasProtocols ? invertedTextColor : '#000000' }}
                            title={iconTitle}
                        />
                    </a>
                </div>
            </div>
        </div>
    );
};
